import './Styles.css';
import React, { memo, useState } from 'react';
import { useAddressSearch } from './Functions';
import { IconButton, IconButtonSize, IconButtonType, IconButtonVariant } from '@ids/react-icon-button';
import { InputFieldWrapper, InputField, InputFieldAddon, InputSize } from '@ids/react-input-field';
import { Ui24Search, Ui32ArrowSmUp, Ui32ArrowSmDown } from '@ids/react-icons';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';
import LoaderComponent from '../../../../ids/Loader';

const AddressSearch = ({ addressState, setAddressState }) => {
  const [query, setQuery] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const list = useAddressSearch(
    query,
    addressState.address.country?.code,
    addressState.address?.format,
    setIsOpen,
    setIsLoading
  );

  return (
    <>
      <InputFieldWrapper
        onClick={() => {
          if (!isOpen) {
            setIsOpen(true);
          }
        }}>
        <InputFieldAddon>
          <Ui24Search aria-hidden />
        </InputFieldAddon>
        <InputField
          inputSize={InputSize.MEDIUM}
          placeholder={formatMessage(Messages.addressInfo_searchPlaceholder)}
          onChange={e => {
            setQuery(e.target.value);
          }}
          value={query}
          autoComplete="off"
        />
        <InputFieldAddon>
          <IconButton
            type={IconButtonType.PLAIN}
            variant={IconButtonVariant.QUIET}
            size={IconButtonSize.X_SMALL}
            onClick={() => {
              if (isOpen) {
                setIsOpen(false);
              }
            }}>
            {isOpen ? <Ui32ArrowSmUp /> : <Ui32ArrowSmDown />}
          </IconButton>
        </InputFieldAddon>
      </InputFieldWrapper>

      {isLoading ? (
        <LoaderComponent />
      ) : (
        <>
          {isOpen && (
            <ul className="formatSwitcher-search-results">
              {list.map(address => (
                <li
                  key={address.id}
                  className="formatSwitcher-search-resultsRow clickable"
                  onClick={() => {
                    setAddressState({
                      ...addressState,
                      address: {
                        ...addressState.address,
                        ...address,
                      },
                    });
                    setIsOpen(false);
                  }}>
                  {address.displayText}
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </>
  );
};

export default memo(AddressSearch);
